import { Delete } from '@mui/icons-material';
import { FormHelperText, Grid, IconButton } from '@mui/material';

import { CurrencyCode } from 'further-types/lp/vehicle';
import BasicSelect from 'further-ui/components/BasicSelect';
import NumberInput from 'further-ui/components/NumberInput';

type Props = {
  index: number;
  transactionErrors?: {
    message?: string;
    transactionTypeId?: { message?: string };
  };
  transaction: {
    transactionTypeId: string;
    debitAmountLcy: number;
    debitAmountTcy: number;
    creditAmountLcy: number;
    creditAmountTcy: number;
  };
  transactionTypeOptions: Array<{ value: string; label: string }>;
  currency: CurrencyCode;
  onTransctionTypeChange: (index: number, value: string) => void;
  onDebitAmountChange: (index: number, value: number) => void;
  onCreditAmountChange: (index: number, value: number) => void;
  onRemove: (index: number) => void;
};

const Transaction: React.FC<Props> = ({
  index,
  transaction,
  currency,
  transactionTypeOptions,
  transactionErrors,
  onTransctionTypeChange,
  onDebitAmountChange,
  onCreditAmountChange,
  onRemove,
}) => {
  return (
    <div>
      <Grid container spacing={2} alignItems="center">
        <Grid size="grow">
          <BasicSelect
            fullWidth
            value={transaction.transactionTypeId}
            options={transactionTypeOptions}
            placeholder="Select transaction type"
            onChange={(value) => {
              onTransctionTypeChange(index, value);
            }}
            error={!!transactionErrors?.transactionTypeId}
            helperText={transactionErrors?.transactionTypeId?.message}
          />
        </Grid>
        <Grid size={3}>
          <NumberInput
            fullWidth
            value={transaction.debitAmountLcy}
            onChange={(value) => {
              onDebitAmountChange(index, value ?? 0);
            }}
            currency={currency}
            decimals={2}
            placeholder="Enter debit amount"
            disabled={transaction.creditAmountLcy > 0}
            error={!!transactionErrors}
          />
        </Grid>
        <Grid size={3}>
          <NumberInput
            fullWidth
            value={transaction.creditAmountLcy}
            onChange={(value) => {
              onCreditAmountChange(index, value ?? 0);
            }}
            currency={currency}
            decimals={2}
            placeholder="Enter credit amount"
            disabled={transaction.debitAmountLcy > 0}
            error={!!transactionErrors}
          />
        </Grid>
        <Grid size={1}>
          {index > 1 && (
            <IconButton
              size="small"
              onClick={() => {
                onRemove(index);
              }}
            >
              <Delete />
            </IconButton>
          )}
        </Grid>
      </Grid>
      {transactionErrors?.message ? (
        <FormHelperText error>{transactionErrors.message}</FormHelperText>
      ) : null}
    </div>
  );
};

export default Transaction;
